module.exports = __webpack_public_path__ + "static/media/svg-11.0cacfcdc.svg";